//#region types
import { AutomationRuleFormTypes } from "models/formTypes";
import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { FormFieldConstants } from "utils/constants";
//#endregion
import * as Yup from "yup";
import { LocalizationHelperInstance } from "utils/helpers";

function useReceiptDraftFormValidation() {
  const receiptDraftValidationScheme = Yup.object<AutomationRuleFormTypes.CreateReceiptDraftRule>({
    category: Yup.object<AutocompleteListItem>().required(TranslationKeys.Validations.Required),
    paymentMethodId: Yup.number().required(TranslationKeys.Validations.Required),
    minimumAmount: Yup.number(),
    maximumAmount: Yup.number().when(
      FormFieldConstants.AutomationRule.CreateReceiptDraftRule.MinimumAmount,
      ([minAmount], schema: Yup.NumberSchema) =>
        (minAmount && schema.min(minAmount, TranslationKeys.Validations.MaxAmountLessThanMinAmount)) || schema
    ),
    maxAutomatedEventsPerMonth: Yup.number()
      .integer(TranslationKeys.Validations.Invalid)
      .min(1, LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Validations.Min, "", { min: "1" })),
    supplier: Yup.object<AutocompleteListItem>().required(TranslationKeys.Validations.Required),
    isActive: Yup.boolean(),
    dimensions: Yup.array().of(
      Yup.object<WintSuperkollAPIModel.DimensionData>({
        dimensionId: Yup.string(),
        amount: Yup.number(),
      })
    ),
  });

  return {
    receiptDraftValidationScheme,
  };
}

export default useReceiptDraftFormValidation;
